import React from 'react';
import styled from 'styled-components';

import Section from '@basic/layouts/Section';
import Text from '@basic/Text';
import HTMLWrapper from './HTMLWrapper';
import Button from '@basic/Button';
import theme from '@theme';

const { colors } = theme;

const CTAWrapper = styled(Section)`
	text-align: center;
	h2 {
		margin-bottom: 20px;
		color: ${colors.white};
	}
	.cta-callout {
		margin-bottom: 40px;
		color: ${colors.white};
		width: 70%;
		margin: 0 auto 30px;
		display: flex;

		p {
			text-align: center;
			color: ${colors.white};
		}
	}
`;

const InnerCTAWrapper = styled.div`
	background: #789ee8;
	background: ${({ bgGradient }) =>
		bgGradient ? bgGradient : colors.gradients.cta};
	padding: 90px;
`;

const CTAButton = styled(Button)`
	width: fit-content;
	margin: 0 auto;
	max-width: 330px;
	display: flex;
`;

const BasicCTA = ({
	headerLevel,
	header,
	subheader,
	buttonText,
	buttonLink,
	button,
	buttonArrow = true,
	className,
	liveComponents,
	bgGradient,
	...props
}) => {
	return (
		<CTAWrapper
			className={`cta-wrapper ${className}`}
			noTopPadding={props.noTopPadding}
			noBottomPadding={props.noBottomPadding}
		>
			<InnerCTAWrapper bgGradient={bgGradient} className="cta-inner">
				<Text component={headerLevel || 'h2'}>{header}</Text>
				{!subheader.indexOf('<p>') ? (
					<HTMLWrapper
						html={subheader}
						className="cta-callout"
						replaceNode={{ p: 'b2' }}
					/>
				) : (
					<Text className="cta-callout" component="b2">
						{subheader}
					</Text>
				)}
				{buttonText && (
					<CTAButton arrow={buttonArrow} link={buttonLink}>
						{buttonText}
					</CTAButton>
				)}
				{button && (
					<CTAButton arrow={buttonArrow} link={button.linkUrl}>
						{button.linkText}
					</CTAButton>
				)}
				{liveComponents}
			</InnerCTAWrapper>
		</CTAWrapper>
	);
};

export default BasicCTA;

export const GiveCardCTA = styled(BasicCTA)`
	.cta-inner {
		background: url('/images/give-card/cta.jpg');
		background-size: cover;
		background-position: center;
		border-radius: 32px;
	}
`;
